import { render, staticRenderFns } from "./OfferDocumentList.vue?vue&type=template&id=e70d2d8e&"
import script from "./OfferDocumentList.vue?vue&type=script&lang=js&"
export * from "./OfferDocumentList.vue?vue&type=script&lang=js&"
import style0 from "./OfferDocumentList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VListItemContent})
